import { render } from "./UiPropJson.vue?vue&type=template&id=dc5d06bc"
import script from "./UiPropJson.vue?vue&type=script&lang=js"
export * from "./UiPropJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__